import React, { Component } from "react";

import print from "../assets/print.png"
import zoom from "../assets/zoom.png"
import download from "../assets/download.png"
import MyInput from "../components/MyInput";
import Dropdown from "../components/Dropdown";
import { addstorepost, adduserPost, editUser, getAllCountries, getRoles, getstores, getStores } from "../Path/Path";
import { withRouter } from "../components/withRouter";
import { editstore } from "../Path/Path";
import { toast } from "react-toastify";
import { Autocomplete, TextField } from "@mui/material";
import { sanitizeStoreInput } from "../helpers/validator";
import BackButton from "../components/BackButton";
import Loader from "../components/Loader";
class Addstore extends Component {
    constructor(props) {
        super(props)

        this.state = {
            name: "",
            type: "",
            status: "Active",
            showtype: false,
            showStatus: false,
            storeCity: "",
            storeMall: "",
            entity: "",
            company: "",
            loading: true,
            wareHouse: "",
            countryData: [],
            countryName: ""
        }
    }

    async componentDidMount() {
        this.setState({ loading: true })
        const data = await getAllCountries()
        this.setState({countryData: data.data?.data})
        this.setState({ loading: false })
        if (this.props.location.state?.item) {

            const item = this.props.location.state.item

            this.setState({
                name: item.Name, storeCity: item.City,
                storeMall: item.Mall, entity: item.Entity, wareHouse: item.Warehouse,

                storeName: item.siteId, type: item.store_type, countryName: item.Country
            })
        }
    }

    sendHanndler = async () => {

        try {

            const name = (this.state.name || "").trim();
            const storeCity = (this.state.storeCity || "").trim();
            const storeMall = (this.state.storeMall || "").trim();
            const entity = (this.state.entity || "").trim();
            const status = (this.state.status || "").trim();
            const type = (this.state.type || "").trim();
            const wareHouse = (this.state.wareHouse || "").trim();
            const countryName = (this.state.countryName || "").trim();

            if (!name) return toast.warn("Enter Store Name");
            if (name.length < 2) return toast.warn("Store Name must be at least 2 characters");
            if (!status) return toast.warn("Select Status");
            if (!storeCity) return toast.warn("Enter Store City");
            if (storeCity.length < 2) return toast.warn("Store City must be at least 2 characters");
            if (!storeMall) return toast.warn("Enter Store Mall");
            if (storeMall.length < 2) return toast.warn("Store Mall must be at least 2 characters");
            if (!entity) return toast.warn("Enter Entity");
            if (entity.length < 2) return toast.warn("Entity must be at least 2 characters");
            if (!type) return toast.warn("Select Store Type");
            if (!wareHouse) return toast.warn("Enter WareHouse");
            if (wareHouse.length < 2) return toast.warn("WareHouse must be at least 2 characters");
            if (!countryName) return toast.warn("Select Country Name");

            const body = {
                "Name": name.trim(),
                "City": storeCity.trim(),
                "Mall": storeMall.trim(),
                "Entity": entity.trim(),
                "status": this.state.status === "Active" ? "1" : "0",
                "store_type": type.trim(),
                "Warehouse": wareHouse.trim(),
                "Country": countryName.trim(),
            }
            
            if (this.props.location?.state?.item) {
                this.setState({ loading: true })
                await editstore(body, this.props.location.state.item._id)
                this.setState({ loading: false })
                toast.success("Store edited successfully")
                await getstores();
                this.props.history("/store")
            }

            else {
                this.setState({ loading: true })
                await addstorepost(body)
                this.setState({ loading: false })
                toast.success("Store added successfully")
                this.props.history("/store")
            }

        } catch (error) {
            this.setState({ loading: false })
            toast.error(
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Something went wrong"
            )
        }
    }

    render() {
        const editMode = !!this.props.location?.state?.item

        return (
        <>
            <Loader loading={this.state.loading} />
            <div className="dashboard-main">
                <div className="dashboard-top">
                    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                        <BackButton />
                        <p className="stock-count" style={{ margin: 0 }}>{ editMode ? "Edit Store" : "Add Store"}</p>
                    </div>
                    <div style={{ display: "flex", width: "13%", justifyContent: "space-between",alignItems: "center", marginTop: "0.3%" }}>
                        <div >
                            <img src={zoom}></img>
                        </div>
                        <div>
                            <img src={print}></img>
                        </div>
                        <div>
                            <img width={30} height={30} src={download}></img>
                        </div>
                    </div>
                </div>
                <div style={{ paddingInline: 20, marginTop: 20, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    {/* <div> <p className="filter-text">Filters</p></div> */}

                    <TextField
                        sx={{ width: 235 }}
                        defaultValue={this.state.name}
                        value={this.state.name}
                        placeholder="Store Name"
                        size={'small'}
                        inputProps={{ maxLength: 50 }}
                        error={this.state.name.trim().length > 0 && this.state.name.trim().length < 2}
                        helperText={
                                this.state.name.trim().length > 0 && this.state.name.trim().length < 2
                                    ? 'Name must be at least 2 characters'
                                    : ''
                            }
                        onChange={(data) => this.setState({ name: sanitizeStoreInput(data.target.value) })} id="outlined-basic" label="Name" variant="outlined" />


                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        size={'small'}
                        value={this.state.status}
                        options={["Active", "Deactive"]}
                        onChange={(e, v) => this.setState({ status: v === null ? '' : v })}
                        sx={{ width: 235 }}
                        renderInput={(params) => <TextField
                            {...params} label="Status" />}
                    />
                    <TextField
                        sx={{ width: 235 }}
                        defaultValue={this.state.storeCity}
                        value={this.state.storeCity}
                        placeholder="Store City"
                        size={'small'}
                        inputProps={{ maxLength: 50 }}
                        error={this.state.storeCity.trim().length > 0 && this.state.storeCity.trim().length < 2}
                        helperText={
                            this.state.storeCity.trim().length > 0 && this.state.storeCity.trim().length < 2
                                ? 'Store City must be at least 2 characters'
                                : ''
                        }
                        onChange={(data) => this.setState({ storeCity: sanitizeStoreInput(data.target.value) })} id="outlined-basic" label="Store City" variant="outlined" />


                </div>

                <div style={{ paddingInline: 20, marginTop: 15, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>

                    <TextField
                        sx={{ width: 235 }}
                        defaultValue={this.state.storeMall}
                        placeholder="Store Mall"
                        value={this.state.storeMall}
                        size={'small'}
                        inputProps={{ maxLength: 50 }}
                        error={this.state.storeMall.trim().length > 0 && this.state.storeMall.trim().length < 2}
                        helperText={
                            this.state.storeMall.trim().length > 0 && this.state.storeMall.trim().length < 2
                                ? 'Store Mall must be at least 2 characters'
                                : ''
                        }
                        onChange={(data) => this.setState({ storeMall: sanitizeStoreInput(data.target.value) })} id="outlined-basic" label="Store Mall" variant="outlined" />

                    <TextField
                        sx={{ width: 235 }}
                        defaultValue={this.state.entity}
                        value={this.state.entity}
                        placeholder="Entity"
                        size={'small'}
                        inputProps={{ maxLength: 50 }}
                        error={this.state.entity.trim().length > 0 && this.state.entity.trim().length < 2}
                        helperText={
                            this.state.entity.trim().length > 0 && this.state.entity.trim().length < 2
                                ? 'Entity must be at least 2 characters'
                                : ''
                        }
                        onChange={(data) => this.setState({ entity: sanitizeStoreInput(data.target.value) })} id="outlined-basic" label="Entity" variant="outlined" />
                    {/* <TextField
                        sx={{ width: 235 }}
                        defaultValue={this.state.company}
                        value={this.state.company}
                        placeholder="Company"
                        size={'small'}
                        onChange={(data) => this.setState({ company: data.target.value })} id="outlined-basic" label="Company" variant="outlined" /> */}
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        size={'small'}
                        value={this.state.type}
                        options={["Ware House", "Store Front"]}
                        onChange={(e, v) => this.setState({ type: v === null ? '' : v })}
                        sx={{ width: 235 }}
                        renderInput={(params) => <TextField
                            {...params} label="Store Type" />}
                    />

                </div>
                <div style={{ paddingInline: 20, marginTop: 15, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>

                    <TextField
                        // disabled={this.state.type === "Ware House" ? false : true}
                        sx={{ width: 235 }}
                        defaultValue={this.state.wareHouse}
                        value={this.state.wareHouse}
                        placeholder="WareHouse"
                        size={'small'}
                        inputProps={{ maxLength: 50 }}
                        error={this.state.wareHouse.trim().length > 0 && this.state.wareHouse.trim().length < 2}
                        helperText={
                            this.state.wareHouse.trim().length > 0 && this.state.wareHouse.trim().length < 2
                                ? 'WareHouse must be at least 2 characters'
                                : ''
                        }
                        onChange={(data) => this.setState({ wareHouse: sanitizeStoreInput(data.target.value) })} id="outlined-basic" label="WareHouse" variant="outlined" />

                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            size="small"
                            value={this.state.countryName}
                            options={Array.isArray(this.state.countryData) ? (
                                this.state.countryData
                                    .map((item) => item?.name) 
                                    .reduce((noDupArr, entry) => {
                                        if (noDupArr?.includes(entry)) {
                                            return noDupArr;
                                        } else {
                                            return [...noDupArr, entry]; 
                                        }
                                    }, [])
                                    .filter((item) => item !== null && item !== undefined) 
                            ) : []} 
                            onChange={(e, v) => this.setState({ countryName: v === null ? '' : v })}
                            sx={{ width: 235 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Country Name"
                                />
                            )}
                        />
                </div>
                <div style={{ paddingLeft: 20, marginTop: 20, marginBottom: 20 }} >
                    <button className="run-btn" 
                    disabled={this.state.loading}
                    onClick={() => this.sendHanndler()}> <p className="run-text"> {editMode ? "Edit Store" : "Add Store"}</p></button>
                </div>
            </div>
</>

        )
    }
}

export default withRouter(Addstore);